import Text from '@components/Text';
import colors from '@constants/colors';
import { ChangeEventHandler, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import ImageIcon from './ImageIcon';
import styles from './styles.module.scss';

interface Props {
    onChange?: ChangeEventHandler<HTMLInputElement>;
}

function FileUploader({ onChange }:Props) {
    const inputRef = useRef<HTMLInputElement>(null);
    const { t } = useTranslation('common');
    return (
        <div className={styles.container}
            onClick={() => inputRef.current?.click()} >
            <Text color={colors.gray5}>
                {t('fileUploader.fileLimit')}
            </Text>
            <ImageIcon/>
            <input type='file' hidden
                onChange={onChange}
                ref={inputRef} />
        </div>
    );
}

export default FileUploader;
